import React from 'react';
import PropTypes from 'prop-types';
import { StyledTabPanelItem } from './StyledComponents';

/*
 * This is just a wrapper for props validation.
 * Not used directly inside "TabPanel" render, but replaced with "Tab"
 */
export const TabWrapper = () => null;

TabWrapper.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const Tab = ({ id, title, path, index, onEnter, onFocus, isActive }) => (
  <StyledTabPanelItem
    id={`tab-item-${id}`}
    payload={{ id, path }}
    onEnter={onEnter}
    onFocus={onFocus}
    className={isActive ? 'active' : ''}
    index={index}
  >
    {title}
  </StyledTabPanelItem>
);

Tab.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  path: PropTypes.string.isRequired,
  onEnter: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  isActive: PropTypes.bool,
};

export default Tab;
